import { ButtonBase } from '@material-ui/core';
import React from 'react';

import { ReactComponent as ArrowDownIcon } from '../../../shared/assets/icons/arrowDown.svg';
import { ReactComponent as ArrowLeftIcon } from '../../../shared/assets/icons/arrowLeft.svg';
import { ReactComponent as ArrowRightIcon } from '../../../shared/assets/icons/arrowRight.svg';
import { ReactComponent as ArrowUpIcon } from '../../../shared/assets/icons/arrowUp.svg';
import { SvgIcon } from './svgIcon';

export const ArrowButton = ({
  onClick,
  style,
  variant,
  disabled = false,
  iconSize,
}: {
  variant: 'left' | 'right' | 'up' | 'down';
  onClick: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  iconSize?: { width: number; height: number };
}) => {
  let arrow = ArrowLeftIcon;
  const size = iconSize || {
    width: 20,
    height: 20,
  };

  if (variant === 'right') {
    arrow = ArrowRightIcon;
  }

  if (variant === 'up' || variant === 'down') {
    arrow = variant === 'up' ? ArrowUpIcon : ArrowDownIcon;
  }

  return (
    <ButtonBase
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        borderRadius: 8,
        background: disabled ? 'rgb(237, 239, 244)' : 'rgb(233, 236, 242)',
        color: disabled ? 'rgb(172, 178, 187)' : '#181F28',
        ...style,
      }}
      disabled={disabled}
    >
      <SvgIcon icon={arrow} {...size} />
    </ButtonBase>
  );
};
